import React from "react";

const Heading = ({ title }) => {
  return <h1 className="title">{title}</h1>;
};

export default Heading;
